// utils/formatString.js
export const formatUnderscoreToSpace = (str) => {
  return str.replace(/_/g, " ");
};
